/**
 * Wrapper around the currency lib to provide prefered defaults for money.
 * By default the symbol is blanked out
 */
import Currency, { type Options} from "currency.js";

export const currencyDefaults: Options = {
  // symbol: '$',
  symbol: '',
  //other options
  // separator: ',',
  // decimal: '.',
  // errorOnInvalid: false,
  // precision: 2,
  // pattern: '!#',
  // negativePattern: '-!#',
  // fromCents: false
}

  // Create a formatter for money without commas
  const moneyFormatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: false // This disables the thousands separator (commas)
  });

export interface Money extends Currency {
  /** formats with the $ or whatever the symbol is prefixed */
  format$(): string
  abs(): Money
}

export default function currency(value?: Currency.Any, opts?: Options): Money {
  const cur = Currency(value, Object.assign({}, currencyDefaults, opts))
  Object.assign(cur, {
    format$: () => cur.format({symbol: '$'}),
    abs: () => currency(Math.abs(cur.value))
  })
  return cur as Money
}

/**
 * Formats a number to always show 2 decimal places without thousand separators.
 * This is useful for displaying monetary values where you want consistent decimal places
 * but don't want the visual clutter of thousand separators.
 * 
 * @param value - The number to format
 * @returns A string representation of the number with exactly 2 decimal places
 * 
 * @example
 * decimalFormatter(1)      // "1.00"
 * decimalFormatter(1.2)    // "1.20"
 * decimalFormatter(1000)   // "1000.00"
 * decimalFormatter(1.234)  // "1.23" (rounds to 2 decimal places)
 */
export function decimalFormatter(value: number): string {
  return moneyFormatter.format(value)
}

